import { ShimmerLabel } from "@circle-react-shared/AiConversation/status/ShimmerLabel";
import { TypingDots } from "@circle-react-shared/AiConversation/status/TypingDots";

import { t } from "@/i18n-js/instance";

export const TranscribingIndicator = () => (
  <div className="flex min-w-0 items-center gap-2" aria-live="polite">
    <TypingDots />
    <ShimmerLabel label={t("circle_ai_home.voice.transcribing")} />
  </div>
);
